import { filtersHelper } from "@/utils";
import { orientationModuleGroupModel } from "@/models/api/orientationModuleGroup.model";

export const orientationModuleHeaderModel = (data) => ({
  uuid: data.uuid,
  name: data.name,
  usageType: data.usage_type,
  durationDays: data.duration_days,
  certUuid: data.cert_uuid ?? data.cert?.uuid ?? null,
  certName: data.cert?.name || data.certificate?.name || "",
  isActive: data.is_active,
  createdAt: filtersHelper.getDateFormat(data.created_at),
  createdBy: data.created_by,
  updatedAt: filtersHelper.getDateFormat(data.updated_at),
  updatedBy: data.updated_by,
  deletedAt: filtersHelper.getDateFormat(data.deleted_at),
  deletedBy: data.deleted_by,
  groups: (data.groups ?? []).map((item) => orientationModuleGroupModel(item)),
});
